<div
  [@shell]
  *ngIf="
    (isShellOpenOrMinimized$ | async) && (showNewChatBubble$ | async) === false
  "
  class="shell"
  [ngClass]="{
    'shell-minimized': isShellMinimized$ | async
  }"
>
  <div class="shell-container">
    <cigna-omni-shell-header></cigna-omni-shell-header>

    <div class="router" [@flyInOut]="animationState$ | async">
      <ng-container
        *ngComponentOutlet="currentComponent$ | async"
      ></ng-container>
    </div>
  </div>
</div>

<div
  [@shell]
  *ngIf="
    (isShellOpenOrMinimized$ | async) &&
    !shouldHideHeader &&
    (showNewChatBubble$ | async)
  "
  class="shell new-box"
  [ngClass]="{
    'shell-minimized': isShellMinimized$ | async
  }"
>
  <div class="shell-container">
    <cigna-omni-shell-header
      *ngIf="(shouldEnablePreChatWelcome$ | async) === false"
    ></cigna-omni-shell-header>
    <cigna-omni-shell-prechat-header
      [isHistory]="isShowHistory$ | async"
      [existingConvId]="existingConvId | async"
      [shouldCloseSplashScreen]="closeSplashScreen$ | async"
      [shouldFocusOnHeader]="shouldFocusOnHeader$ | async"
      (printEmitter)="printTranscript()"
      *ngIf="shouldEnablePreChatWelcome$ | async"
    ></cigna-omni-shell-prechat-header>
    <div class="router" [@flyInOut]="animationState$ | async">
      <ng-container
        *ngComponentOutlet="currentComponent$ | async"
      ></ng-container>
    </div>
  </div>
</div>
